module.exports = __webpack_public_path__ + "02_long_brown.0edb0b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_long_brown.png
// module id = ACma
// module chunks = 0